<template>
  <div class="team">
    <div class="team_wrap container">
      <PagesTeamComponentsTeamInfo
        :description="data.description || ''"
        :logo="data.logo || ''"
        :social="data.social || {} as ProPlayerSocial"
        :title="data.title || ''"
      />

      <section class="team__players">
        <div class="f fs team__players__header">
          <svg
            class="light"
            height="24"
            width="24"
          >
            <use xlink:href="/icons/sprite.svg#i-soldier" />
          </svg>
          <h2>CS2 {{ t('players') }}</h2>
        </div>

        <div class="team__players__grid">
          <PlayerCard
            v-for="player in (data.players || []) as ProPlayer[]"
            :key="player.id"
            :player="player"
          />
        </div>
      </section>

      <section
        v-if="data.gears?.length"
        class="team__hardware"
      >
        <h2>{{ t('hardware_used_by', { name: data.title }) }}</h2>

        <div class="team__players__grid">
          <Hardware
            v-for="gear in computedGears as Gear[]"
            :key="gear.id"
            :item="gear"
          />
        </div>
        <PaginateV3
          v-if="Math.round((data.gears?.length || 0) / limit) > 1"
          v-model="page"
          :pages-length="Math.round((data.gears?.length || 0) / limit)"
          :total="data.gears?.length || 0"
          :total-items="(data.gears?.length || 0) > limit * page
            ? limit * page
            : (data.gears?.length || 0)
          "
        />
      </section>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { Gear, ProPlayer, ProPlayerSocial, ProTeam } from '~/graphql/generated/schema-types';
import Hardware from '~/components/Pages/Team/Components/Hardware.vue';
import PlayerCard from '~/components/Pages/Team/Components/PlayerCard.vue';

const props = defineProps<{
  loading: boolean
  data: ProTeam
}>();

const { t } = useI18n();
const page = ref(1);
const limit = ref(12);

const computedGears = computed(() => {
  return (props.data.gears || []).slice((page.value - 1) * limit.value, page.value * limit.value);
});
</script>

<style lang="scss" scoped>
.team {
  &_wrap {
    margin-top: 3.2rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 4.8rem;
    padding-bottom: 50px;

    @media screen and (max-width: 1250px) {
      margin-top: 0;
    }
    @media screen and (max-width: 525px) {
      gap: 24px;
    }
  }

  &__players {
    &__header {
      gap: 12px;
      margin-bottom: 24px;

      h2 {
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
      }

      svg {
        width: 28px;
        height: 28px;
      }

      @media screen and (max-width: 525px) {
        gap: 8px;
        margin-bottom: 20px;
        h2 {
          font-size: 20px;
          line-height: 28px;
        }

        svg {
          width: 24px;
          height: 24px;
        }
      }

    }

    &__grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(192px, 1fr));
      gap: 16px;

      @media screen and (max-width: 768px) {
        gap: 12px;
        grid-template-columns: repeat(auto-fill, minmax(135px, 1fr));
      }
    }
  }

  &__hardware {
    h2 {
      font-size: 24px;
      font-weight: 600;
      line-height: 32px;
      margin-bottom: 24px;

      @media screen and (max-width: 525px) {
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
